export default __webpack_public_path__ + "e67804be5188ca2735e317c3e5d0dbd1.png";